import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import { useQuery } from 'react-query';
import { useAuthStore } from './store/auth';
import { authApi } from './api';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Keywords from './pages/Keywords';
import Contents from './pages/Contents';
import Users from './pages/Users';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/Layout';

// 首页重定向组件
const HomeRedirect: React.FC = () => {
  const { user } = useAuthStore();
  
  if (user?.role === 'admin') {
    return <Navigate to="/dashboard" replace />;
  } else {
    return <Navigate to="/contents" replace />;
  }
};

const App: React.FC = () => {
  const { setUser, setLoading, isAuthenticated, isLoading } = useAuthStore();

  // 检查用户登录状态
  const { isLoading: queryLoading } = useQuery(
    'currentUser',
    () => authApi.getCurrentUser(),
    {
      enabled: !!localStorage.getItem('access_token'),
      onSuccess: (response) => {
        setUser(response.data);
      },
      onError: () => {
        setUser(null);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  useEffect(() => {
    if (!localStorage.getItem('access_token')) {
      setLoading(false);
    }
  }, [setLoading]);

  // 显示加载页面
  if (isLoading || queryLoading) {
    return (
      <Layout style={{ height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
        <Spin size="large" />
      </Layout>
    );
  }

  return (
    <Routes>
      {/* 登录页面 */}
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/" replace /> : <Login />
        }
      />
      
      {/* 受保护的路由 */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Routes>
                <Route path="/" element={<HomeRedirect />} />
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute adminOnly>
                      <Dashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/contents" element={<Contents />} />
                <Route path="/keywords" element={<Keywords />} />
                <Route
                  path="/users"
                  element={
                    <ProtectedRoute adminOnly>
                      <Users />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default App; 